import { HitsRelation } from './hits-relation';
import { SearchResult } from './search-result';
import { SortOrder } from './sort-order/sort-order.enum';
import { TotalHits } from './total-hits';

export class SearchTabState {
  searchResult: SearchResult = new SearchResult();

  resultInteracted = false;

  foundAssets: TotalHits = {
    value: 0,
    relation: HitsRelation.Eq,
  };

  sortTerm = '';

  order: SortOrder = SortOrder.DESC;

  constructor(initialValues: Partial<SearchTabState> = {}) {
    Object.assign(this, initialValues);
  }
}
